<script>
    import {
        InputText,
        Typography,
        Button,
        Alert,
        ScrollBox,
        CheckBox,
    } from '$lib/components/UI'
    import Select from '$lib/components/UI/Select2.svelte'
    import { onMount } from 'svelte'
    import MultiSelect from '$lib/components/UI/MultiSelect.svelte'
    import {
        stringSimilarity,
        validarCp,
        validateEmail,
        getLocationFromAth,
        validarTelefono,
    } from '$lib/utils'
    import { fade } from 'svelte/transition'
    import dictionaries from '../../stores/dictionaries'
    export let data = {}
    export let style = ''
    export let editable = true
    export let valid = false

    let isInicializated = Object.keys(data)?.length > 0
    let locationMetadata = {}
    let validations = {}
    // let initialLocation = getLocationFromAth(data.ubicacion)
    // let {lat, lng} = initialLocation
    const productos_dict = [
        { value: '1', label: 'CERRADURAS' },
        { value: '2', label: 'CRISTALES' },
        { value: '3', label: 'RUEDAS' },
    ]

    onMount(() => {
        if (!data.jurisdicciones) data.jurisdicciones = []
    })

    function fillForm(locationMeta) {
        data.cp = locationMeta?.address?.postcode || ''
        data.calle = locationMeta?.address?.road || ''
        data.localidad = locationMeta?.address?.state_district || ''
        data.numero = locationMeta?.address?.house_number || ''
        data.barrio =
            locationMeta?.address?.neighbourhood ||
            locationMetadata?.address?.suburb ||
            ''
        console.log({ locationMeta })
        let resolved = resolveValue(
            locationMeta?.address?.state,
            $dictionaries.vprovincias,
            {
                'Ciudad Autónoma de Buenos Aires': 'Ciudad de Buenos Aires',
                'Buenos Aires': 'Provincia de Buenos Aires',
            }
        )
        console.log({ resolved })
        data.jurisdiccion = resolved[0]
    }

    function resolveValue(labelSearch, list, exceptions = {}) {
        let ret,
            p = -1
        if ((labelSearch || '') in exceptions)
            labelSearch = exceptions[labelSearch]
        if (labelSearch && list instanceof Array) {
            for (let { label, value } of list) {
                p++
                let rgx = /^provincia\s+de\s+/i
                label = label.replace(rgx, '')
                labelSearch = labelSearch.replace(rgx, '')
                let r = stringSimilarity(label, labelSearch, 2, false)
                // console.log(labelSearch, label, r)
                if (r >= 0.85) {
                    ret = value
                    break
                }
            }
        }
        return [ret, ret !== undefined ? p : -1]
    }

    $: if (locationMetadata && !isInicializated) {
        fillForm(locationMetadata)
    }
    // $: data.ubicacion = lat && lng ? `${lat}, ${lng}` : ''
    $: validations.productos = data.productos?.length > 0
    $: validations.jurisdicciones = data.virtual
        ? data.jurisdicciones?.length > 0
        : true
    $: valid = Object.values(validations).every((x) => x === true)
    $: disabled = !editable
    $: errMsgs = Object.entries({
        nombre: 'El campo "Nombre" es obligatorio',
        calle: 'El campo "Calle" es obligatorio',
        cp: 'El campo "Código Postal" es obligatorio',
        numero: 'El campo "Altura/Número" es obligatorio',
        jurisdiccion: 'El campo "Jurisdiccion" es obligatorio',
        jurisdicciones: 'Debe agregar al menos una provincia donde operar.',
        productos: 'Debe agregar al menos una categoria',
        email: 'Debe agregar un email de contacto.',
        tel: 'Debe agregar un teléfono de contacto.',
    })
        .filter(([field]) => !validations[field])
        .map(([_, msg]) => msg)
    let prod = Object.fromEntries(
        productos_dict.map((x) => [
            x.label,
            (data.productos || []).includes(x.value),
        ])
    )
    $: data.productos = Object.entries(prod)
        .filter((e) => e[1])
        .map((e) => productos_dict.find((r) => r.label === e[0])?.value)
    $: jurisdicciones = $dictionaries.jurisdicciones?.filter((j) =>
        /^\d+$/.test(j.value) || j.value === 'RL-2'
    ) || []
</script>

<div class="container" {style}>
    <!-- <div class="picker">
        <LocationPicker bind:lat bind:lng searchBar={editable} {disabled} bind:locationMetadata/>
    </div> -->
    <span style="width: 100%; position: relative">
        <ScrollBox width="100%" height="100%">
            <InputText
                label="Nombre"
                info="Nombre representativo de la sucursal"
                placeholder="Ej: Casa Central"
                {disabled}
                validation={(s) => s && s?.length > 3}
                errorMsg="Ingrese un nombre valido"
                maxLength={100}
                bind:value={data.nombre}
                bind:valid={validations.nombre}
                required
            />
            <Select
                validation={(x) => x !== undefined}
                bind:value={data.jurisdiccion}
                bind:valid={validations.jurisdiccion}
                {disabled}
                label="Jurisdicción"
                options={jurisdicciones}
                required
            />
            <InputText
                {disabled}
                bind:value={data.localidad}
                validation={(r) => r && r !== ''}
                bind:valid={validations.localidad}
                label="Localidad"
            />
            <InputText {disabled} bind:value={data.barrio} label="Barrio" />
            <InputText
                {disabled}
                bind:value={data.calle}
                bind:valid={validations.calle}
                validation={(r) => r && r?.length >= 3}
                maxLength={150}
                label="Calle"
            />
            <InputText
                {disabled}
                bind:value={data.numero}
                bind:valid={validations.numero}
                label="Altura/Número"
                validation={(n) => /[0-9]{2,}/.test(n)}
                maxLength={5}
                required
            />
            <InputText
                {disabled}
                bind:value={data.cp}
                errorMsg="Ingrese un cod. postal real"
                bind:valid={validations.cp}
                validation={validarCp}
                label="Código Postal"
                required
            />
            <InputText
                {disabled}
                bind:value={data.email}
                errorMsg="Ingrese una dirección correo electrónico válida"
                bind:valid={validations.email}
                validation={validateEmail}
                label="Email de contacto"
                required
            />
            <InputText
                {disabled}
                bind:value={data.tel}
                errorMsg="Ingrese un número de teléfono válido"
                bind:valid={validations.tel}
                maxLength={18}
                validation={validarTelefono}
                label="Teléfono de contacto"
                required
            />
            <CheckBox
                {disabled}
                bind:value={data.virtual}
                label="Proveo a otras jurisdicciones desde mi sucursal"
            />
            {#if data.virtual}
                <span in:fade>
                    <MultiSelect
                        validation={(x) => x !== undefined}
                        bind:value={data.jurisdicciones}
                        {disabled}
                        label="Jurisdicciones"
                        options={jurisdicciones}
                        maxItems={25}
                        required
                    />
                    <span style="display: flex; gap: 5px; flex-direction: rows">
                        <Button
                            label={'Seleccionar todas' +
                                ((jurisdicciones?.length || 25) - data.jurisdicciones.length > 0
                                    ? ' (+' +
                                      String((jurisdicciones?.length || 25) - data.jurisdicciones.length) +
                                      ')'
                                    : '')}
                            size="small"
                            style="width: 100%"
                            disabled={disabled ||
                                (data.jurisdicciones || []).length == 25}
                            on:click={() =>
                                (data.jurisdicciones =
                                    jurisdicciones.map(
                                        (t) => t.value
                                    ))}
                        />
                        <Button
                            disabled={disabled || !data.jurisdicciones?.length}
                            size="small"
                            type="other"
                            on:click={() => {
                                data.jurisdicciones = []
                            }}>Limpiar</Button
                        >
                    </span>
                    {#if !disabled}
                        <Alert type="info" style="margin-top: 15px">
                            <strong style="font-weight: 800; text-decoration: double;">Partido de La Costa:</strong> Comprendido por las localidades bonaerenses de Partido de la Costa, Villa Gesell, Pinamar, General Pueyrredón, General Alvarado, Mar Chiquita y Necochea (exclusivamente).
                        </Alert>
                    {/if}
                </span>
            {/if}
            <!-- <InputTag
                label="Categorias"
                placeholder="Agrege al menos un elemento"
                bind:value={data.productos}
                {disabled}
                validation={t => Object.values(categoriasServicios).includes(t)}
                options={productos_dict}
            /> -->
            <Typography type="caption" color={disabled ? 'grey-400' : 'black'}
                >Productos que provee la sucursal</Typography
            >
            <CheckBox {disabled} bind:value={prod.RUEDAS}>Ruedas</CheckBox>
            <CheckBox {disabled} bind:value={prod.CRISTALES}>Cristales</CheckBox
            >
            <CheckBox {disabled} bind:value={prod.CERRADURAS}
                >Cerraduras</CheckBox
            >
            {#if !valid && editable}
                <Alert type="error" style="margin-top: 15px">
                    <p>Por favor tenga en cuenta que:</p>
                    <ul>
                        {#each errMsgs as msg}
                            <li>{msg}</li>
                        {/each}
                    </ul>
                </Alert>
            {/if}
        </ScrollBox>
    </span>
</div>

<style>
    .container {
        display: flex;
        flex-direction: row;
        position: relative;
        width: 100%;
        height: 100%;
        max-height: 100%;
        gap: 35px;
        padding: 25px 25px;
    }
</style>
